module.exports = __webpack_public_path__ + "img/777.f1bd497c.gif";